<template>
  <ValidationObserver ref="organizationForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-form rel="organizationForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextAreaWithValidation
                  v-model="value.content"
                  rules="required"
                  outlined
                  dense
                  label="Obsah"
                  data-cy="content"
                />
              </v-col>
            </v-row>
            <v-row v-if="!edit">
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.whom"
                  label="Komu"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="messageWhom"
                  item-text="text"
                  item-value="name"
                  :loading="messageWhomLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row v-if="value.whom === 'INDIVIDUAL'" class="pb-6">
              <v-col cols="12" sm="6" class="py-0 px-5">
                <CustomerUserAutocomplete v-model="value.userId" :items="users" :contact="true" />
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="loading"
              >
                <div v-if="edit">Uložit</div>
                <div v-else>Vytvořit</div>
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
import VTextAreaWithValidation from '../validators/VTextAreaWithValidation'
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'
import CustomerUserAutocomplete from './inputs/CustomerUserAutocomplete'

export default {
  name: 'MessageForm',
  components: {
    CustomerUserAutocomplete,
    VAutocompleteWithValidation,
    VTextAreaWithValidation,
  },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      users: [],
      messageWhom: [],
      messageWhomLoading: false,
    }
  },
  created() {
    this.loadMessageWhom()
  },
  methods: {
    ...mapActions({
      listMessageWhom: 'enum/listMessageWhom',
    }),
    loadMessageWhom() {
      this.messageWhomLoading = true
      this.listMessageWhom()
        .then((response) => {
          this.messageWhom = response.data
        })
        .finally(() => {
          this.messageWhomLoading = false
        })
    },
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
